import axios from 'axios';

const API_BASE = '/api/v1/auth';

/**
 * Log in a user and establish a secure session via HttpOnly cookies.
 */
export const login = async (identifier: string, password: string) => {
  const response = await axios.post(`${API_BASE}/login`, { identifier, password }, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Log out the user and clear the secure session.
 */
export const logout = async () => {
  const response = await axios.post(`${API_BASE}/logout`, {}, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Fetch the current user's identity based on the session cookie.
 */
export const getMe = async () => {
  const response = await axios.get(`${API_BASE}/me`, {
    withCredentials: true
  });
  return response.data;
};
